import { Box, SxProps } from "@mui/material"
import { useNavigate } from "react-router-dom"
import SimpleBar from "simplebar-react"

import { VerticalEventCard } from "components/domains/events"
import { IFeature } from "interfaces"

export type TLayoutType = "carousel" | "grid"

interface IFeatureGridLayoutProps {
  sx?: SxProps
  features: IFeature[]
  layoutType: TLayoutType
  linkPrefix?: string
}

export const FeatureGridLayout = ({
  sx,
  features,
  layoutType,
  linkPrefix = "/events",
}: IFeatureGridLayoutProps) => {
  const navigate = useNavigate()

  return (
    <SimpleBar
      style={{
        width: "100%",
        height: "100%",
        overflow: "hidden auto",
      }}
    >
      <Box sx={sx}>
        {features.map((feature) => {
          const sponsoredId = feature?.properties?.sponsoredId

          return (
            <Box
              onClick={() => navigate(`${linkPrefix}/${feature.id}`)}
              key={`${sponsoredId || ""}${feature.id}`}
            >
              <VerticalEventCard
                event={feature}
                className={`EventLayoutType-${layoutType}`}
              />
            </Box>
          )
        })}
      </Box>
    </SimpleBar>
  )
}
